export default __webpack_public_path__ + "images/youtube-icon_6edb3e4552b9c2b0d4960ccdffd28113.svg";